import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import Moment from "moment";
import Select from "react-select";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  Modal,
  ModalBody,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { number } from "prop-types";
import { InfinitySpin, Oval, Hourglass } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import { getJenisPenilaian } from "stores";
import { updateStatusFormGroup } from "stores";
import Swal from "sweetalert2";
import { addGroupFormPenilaian } from "stores";
import { addJenisPenilaian } from "stores";
import KriteriaPenilaian from "./KriteriaPenilaian";
import "./Pagination.css";

function JenisPenilaian(data) {
  const auth = useSelector((state) => state.authReducer);
  const listScoring = useSelector((state) => state.scoringReducer);
  const [modal, setModal] = React.useState(false);
  const dispatch = useDispatch();
  const [listJenisPenilaian, setListJenisPenilaian] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [namaJenisPenilaian, setNamaJenisPenilaian] = React.useState("");
  const [bobotPenilaian, setBobotPenilaian] = React.useState(0);
  const [sisaBobot, setSisaBobot] = React.useState(0);
  const [idUsaha, setIdUsaha] = React.useState("");
  const [sendVal, setSendVal] = React.useState("");
  const [idJenisPenilaian, setIdJenisPenilaian] = React.useState("");

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleFilterChange = () => {
    setPending(true);
    getJenisPenilaian(dispatch, {
      idGroupFormPenilaian: data.data,
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_USAHA", data: false });
    setIdUsaha(val.idUsaha);
    setSendVal(val);

    // dispatch({ type: "SET_KIRIM_DETAIL_NASABAH", data: val });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const tambahJenisPenilaian = () => {
    if ((!namaJenisPenilaian, !bobotPenilaian)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Semua form wajib diisi!",
      });
    } else {
      addJenisPenilaian({
        idGroupFormPenilaian: data.data,
        jenisPenilaian: namaJenisPenilaian,
        bobot: bobotPenilaian,
      })
        .then((response) => {
          if (response.status === 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.message,
              showConfirmButton: false,
              timer: 1500,
            });
            setModal(false);
            getJenisPenilaian(dispatch, {
              idGroupFormPenilaian: data.data,
              page: page + 1,
              limit: totalPerHalaman,
              cari: searchText,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        })
        .catch((err) => {
          console.log("ERROR :", err);
        });
    }
  };

  const getStatusFormPenilaian = (status) => {
    switch (status) {
      case true:
        return {
          fontWeight: "bold",
          backgroundColor: "#D4FFC6",
          textColor: "#2AAA00",
        };
      case false:
        return {
          fontWeight: "bold",
          backgroundColor: "#FBECEC",
          textColor: "#DB5856",
        };

      default:
        return {};
    }
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const customStyles = {
    rows: {
      style: {
        height: 50, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const tampilKriteriaPenilaian = (val) => {
    dispatch({ type: "SET_SHOW_KRITERIA_PENILAIAN", data: false });
    dispatch({ type: "SET_SHOW_PARAMETER_PENILAIAN", data: true });
    setIdJenisPenilaian(val);
  };

  React.useEffect(() => {
    if (listScoring.getListJenisPenilaian.data) {
      let sisaBobot = 0;
      let tmp = listScoring.getListJenisPenilaian.data.map((val) => {
        sisaBobot += val.bobot;
        return {
          ...val,
          action: (
            <>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Tambah Kriteria Penilaian</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#00555A",
                    border: 0,
                  }}
                  onClick={() => {
                    tampilKriteriaPenilaian(val);
                  }}
                >
                  <i class="fas fa-layer-group"></i>
                </Button>
              </OverlayTrigger>{" "}
              {/* <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Usaha</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#65869F",
                    border: 0,
                  }}
                  onClick={() => handleDetailsClick(val)}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger> */}
            </>
          ),
        };
      });
      setSisaBobot(100 - sisaBobot);
      setListJenisPenilaian(tmp);
    }
  }, [listScoring.getListJenisPenilaian]);

  React.useEffect(() => {
    setPending(true);
    getJenisPenilaian(dispatch, {
      cari: searchText,
      idGroupFormPenilaian: data.data,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then(() => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [data.data, page, totalPerHalaman]);

  const colListJenisPenilaian = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) =>
        index + listScoring.getListJenisPenilaian.pagingCounter,
    },
    // {
    //   name: "ID Grup",
    //   minWidth: "200px",
    //   center: true,
    //   selector: (row) => row.idGroupFormPenilaian,
    // },
    {
      name: "ID Jenis Penilaian",
      minWidth: "200px",
      center: true,
      selector: (row) => row.idJenisPenilaian,
    },
    {
      name: "Nama Jenis Penilaian",
      minWidth: "200px",
      center: true,
      selector: (row) => row.jenisPenilaian,
    },
    {
      name: "Bobot",
      minWidth: "200px",
      center: true,
      selector: (row) => row.bobot,
    },

    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  return (
    <>
      <Modal
        size="lg"
        show={modal}
        onHide={() => {
          // handleModalClose();
          setModal(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title
                as="h5"
                style={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Form Tambah Jenis Penilaian
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <label style={{ color: "black", fontWeight: "bold" }}>
                        Nama Jenis Penilaian
                      </label>
                      <Form.Control
                        onChange={(e) => {
                          setNamaJenisPenilaian(e.target.value);
                        }}
                        placeholder="Nama Jenis Penilaian"
                        type="text"
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label style={{ color: "black", fontWeight: "bold" }}>
                        Bobot Penilaian
                      </label>
                      <Form.Control
                        onChange={(e) => {
                          setBobotPenilaian(e.target.value);
                        }}
                        placeholder="Bobot penilaian"
                        type="number"
                        className="no-spinner"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                onClick={tambahJenisPenilaian}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>
      {!auth.role ? (
        <Container
          fluid
          className=" d-flex justify-content-center align-items-center"
        >
          <Row>
            <Col className="text-center">
              <span
                style={{
                  fontWeight: "bold",
                  color: "blue",
                  fontSize: 20,
                }}
              >
                {/* Loading... */}
              </span>
            </Col>
          </Row>
        </Container>
      ) : auth.role !== "super admin" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            flexDirection: "column",
            // backgroundColor: "red",
          }}
        >
          <p
            style={{
              fontWeight: "bold",
              marginBottom: "1rem",
              fontSize: 30,
              color: "red",
            }}
          >
            Maaf, Anda tidak memiliki akses ke fitur ini!
          </p>
          <img
            src={require("assets/img/sorry.png").default}
            alt="Sorry"
            style={{
              maxWidth: "25%",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>
      ) : (
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Row
                    style={{
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Card.Title
                      as="h3"
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      jenis penilaian
                    </Card.Title>
                    <Button
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#FF2C2C",
                        border: 0,
                      }}
                      onClick={() => {
                        // console.log("MAUSK");
                        dispatch({
                          type: "SET_SHOW_JENIS_PENILAIAN",
                          data: true,
                        });
                        dispatch({
                          type: "SET_SHOW_KRITERIA_PENILAIAN",
                          data: true,
                        });
                        dispatch({
                          type: "SET_SHOW_PARAMETER_PENILAIAN",
                          data: true,
                        });
                      }}
                    >
                      X
                    </Button>
                  </Row>

                  {/* <p className="card-category">Plain text tabs</p> */}
                  <Tab.Content>
                    <Card style={{ marginTop: 10, border: 0 }}>
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Col md={"4"}>
                          <InputGroup>
                            <Form.Control
                              style={{
                                paddingLeft: "10px",
                              }}
                              type="text"
                              value={searchText}
                              onChange={handleSearch}
                              onKeyDown={handleKeyDown}
                              placeholder="Nama Jenis Penilaian"
                            />
                            <InputGroup.Append>
                              <InputGroup.Text
                                style={{ cursor: "pointer" }}
                                onClick={handleClearSearch}
                              >
                                <i class="fas fa-times"></i>
                              </InputGroup.Text>
                            </InputGroup.Append>
                          </InputGroup>
                        </Col>
                        <Col md={"8"}>
                          <Button
                            // variant="info"
                            style={{
                              fontSize: 16,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingTop: 10,
                              paddingBottom: 8,
                            }}
                            onClick={handleFilterChange}
                          >
                            <i class="fas fa-search"></i>
                          </Button>
                        </Col>
                      </Row>
                      <Row className="d-flex flex-column">
                        <Col style={{ marginTop: 5 }}>
                          <label
                            style={{
                              fontWeight: "bold",
                              color: "blue",
                              fontSize: 15,
                            }}
                          >
                            {" "}
                            ID Grup Penilaian : {data.data}
                          </label>
                        </Col>
                        <Col>
                          <label
                            style={{
                              fontWeight: "bold",
                              color: "red",
                              fontSize: 15,
                            }}
                          >
                            {" "}
                            Sisa Bobot : {sisaBobot}
                          </label>
                        </Col>
                      </Row>
                    </Card>
                  </Tab.Content>
                </Card.Header>
                <Card.Body>
                  <Button
                    className="btn-wd"
                    variant="primary"
                    style={{
                      // marginLeft: 0,
                      // marginTop: 10,
                      backgroundColor: "#425A6B",
                      border: 0,
                      marginBottom: 15,
                    }}
                    onClick={() => {
                      setModal(true);
                    }}
                  >
                    Tambah Jenis
                  </Button>
                  {pending ? (
                    <div
                      className="loader-container"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <div style={{ marginBottom: 20 }}>
                        <Hourglass
                          visible={true}
                          height="50"
                          width="50"
                          ariaLabel="hourglass-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          colors={["#306cce", "#72a1ed"]}
                        />
                        {/* <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 19,
                      }}
                    >
                      Loading ....
                    </p> */}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <DataTable
                        columns={colListJenisPenilaian}
                        data={listJenisPenilaian}
                        customStyles={customStyles}
                        paginationPerPage={totalPerHalaman}
                        progressPending={pending}
                      />
                      <div style={{ marginTop: 35 }}>
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Col>
                            <Row style={{ alignItems: "center" }}>
                              <div
                                style={{
                                  paddingRight: 0,
                                  marginLeft: 20,
                                  marginRight: 10,
                                }}
                              >
                                <label style={{ fontWeight: "bold" }}>
                                  Rows per page
                                </label>
                              </div>
                              <Col sm="3" style={{ paddingLeft: 0 }}>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="Pilih Client"
                                  value={options.find(
                                    (option) => option.value === totalPerHalaman
                                  )}
                                  onChange={handlePageSizeChange}
                                  options={options}
                                  placeholder="Rows per page"
                                />
                              </Col>
                            </Row>
                          </Col>

                          <Col>
                            <ReactPaginate
                              forcePage={page}
                              containerClassName="paginations justify-content-end"
                              previousClassName="pages-items-containers"
                              previousLinkClassName="pages-links-labels"
                              nextClassName="pages-items-containers"
                              nextLinkClassName="pages-links-labels"
                              breakClassName="pages-items-containers"
                              pageCount={
                                listScoring.getListJenisPenilaian.totalPages
                              }
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageLinkClassName="pages-links-labels"
                              pageClassName="pages-items-containers"
                              activeClassName="activees"
                              activeLinkClassName="activess"
                              nextLabel=" > "
                              previousLabel=" < "
                              initialPage={page}
                              disableInitialCallback={true}
                              onPageChange={(val) => {
                                setPage(val.selected);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
      {listScoring.showTabelKriteriaPenilaian ? null : (
        <KriteriaPenilaian
          data={idJenisPenilaian.idJenisPenilaian}
          value={idJenisPenilaian}
        />
      )}
    </>
  );
}

export default JenisPenilaian;
